import React from 'react';
import { Layout, Typography, Card, Row, Col, Tag } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const systems = [
    {
        name: 'AI Challenges',
        status: 'Operational',
    },
    {
        name: 'Mentorship Program',
        status: 'Degraded Performance',
    },
    {
        name: 'Job Board',
        status: 'Operational',
    },
    {
        name: 'Assessments',
        status: 'Partial Outage',
    },
    {
        name: 'AI Learning Modules',
        status: 'Operational',
    },
    {
        name: 'Plagiarism Detection',
        status: 'Under Maintenance',
    },
    {
        name: 'Cybersecurity Tools',
        status: 'Operational',
    },
    {
        name: 'Data Science Projects',
        status: 'Degraded Performance',
    },
];

const getStatusTag = (status) => {
    switch (status) {
        case 'Operational':
            return <Tag color="green">{status}</Tag>;
        case 'Degraded Performance':
            return <Tag color="orange">{status}</Tag>;
        case 'Partial Outage':
            return <Tag color="red">{status}</Tag>;
        case 'Under Maintenance':
            return <Tag color="blue">{status}</Tag>;
        default:
            return <Tag>{status}</Tag>;
    }
};

function AISystemStatus() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>AI System Status</Title>
                <Paragraph>
                    Stay updated on the status of JectHub's AI services. Below is the current status of our key systems.
                </Paragraph>
                <Row gutter={[16, 16]}>
                    {systems.slice(0, 4).map((system, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={system.name} bordered={false}>
                                <Paragraph><strong>Status: </strong>{getStatusTag(system.status)}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <hr style={{ margin: '40px 0' }} />
                <Row gutter={[16, 16]}>
                    {systems.slice(4, 8).map((system, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={system.name} bordered={false}>
                                <Paragraph><strong>Status: </strong>{getStatusTag(system.status)}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default AISystemStatus;
